export default __webpack_public_path__ + "static/media/arrow-right.af0e3d36.svg";